import React from 'react';

import { isError } from '@tanstack/react-query';

import styles from './Blurb.module.scss';

type BlurbProps = {
	className?: string;
	isError?: boolean;
};

export const Blurb: React.FC<BlurbProps> = ({
	className,
	children,
	isError,
}) => {
	const classes = [styles.blurb, className, isError && styles.error].filter(
		Boolean,
	);

	return <div className={classes.join(' ')}>{children}</div>;
};
